document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(
    'section[id^="homepage-blocks-section-"]'
  );
  let homepageBlocks = [];

  function bottomOfTheBlockHandler(homepageBlock) {
    const rect =
      homepageBlock.block && homepageBlock.block.getBoundingClientRect();

    // If you can see the end of the block
    const isAtBottom = window.innerHeight - rect.bottom >= 0;
    if (isAtBottom) {
      homepageBlock.rightText.classList.add("opacity-1");
      homepageBlock.rightText.classList.remove("opacity-0");
    } else {
      homepageBlock.rightText.classList.remove("opacity-1");
      homepageBlock.rightText.classList.add("opacity-0");
    }
  }

  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  };

  const scrollHandler = () => {
    homepageBlocks.forEach((homepageBlock) =>
      bottomOfTheBlockHandler(homepageBlock)
    );
  };

  const debouncedScrollHandler = debounce(scrollHandler, 3);

  sections.forEach((section) => {
    const blocks = section.querySelectorAll('[id^="wrapper-"]');
    const titles = section.querySelectorAll('[id^="titles-"]');
    const rightTexts = section.querySelectorAll('[id^="right-text-"]');

    blocks.forEach((block, index) => {
      homepageBlocks.push({
        block,
        title: titles[index],
        rightText: rightTexts[index],
      });
    });
  });

  const applyStyles = () => {
    if (window.innerWidth < 990) {
      homepageBlocks.forEach((homepageBlock) => {
        homepageBlock.block.style.height = "var(--initial-viewport-height)";
        bottomOfTheBlockHandler(homepageBlock);
      });
      window.addEventListener("scroll", debouncedScrollHandler);
    } else {
      homepageBlocks.forEach((homepageBlock) => {
        homepageBlock.block.style.removeProperty("height");
      });
      window.removeEventListener("scroll", debouncedScrollHandler);
    }
  };

  window.addEventListener("resize", applyStyles);
  applyStyles();
});
